/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const AddSafemate = props => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    <path
      d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm8.836-18.24H18.24V7.164a2.24 2.24 0 00-4.48 0v6.596H7.164a2.24 2.24 0 000 4.48h6.596v6.596a2.24 2.24 0 104.48 0V18.24h6.596a2.24 2.24 0 100-4.48z"
      fillRule="evenodd"
    />
  </svg>
);
export default extendIcon(AddSafemate);
